import React from 'react'
import { V2ProductQuantity } from 'src/views/components/ProductComponents/ProductSkuDetails/ProductQuantity/V2ProductQuantity'
import { observer } from 'mobx-react'
import { PriceButtonsForPDP } from 'src/views/components/ProductComponents/ProductSkuDetails/PriceButtonsForPDP'
import { productState } from 'src/views/components/BaseProductComponent/ProductState'
import {
  i18nTranslate,
  getLiveEventStatus,
  ApiContent,
  convertToBoolean,
  checkAgreedTermStatus,
  retriveAgreement,
  isGuestCheckoutEnabledForWeb,
  enableNewFeature,
  isFeatureEnabled,
  isNonEventOrEventWithSub,
  trackV2SubscriptionButtonClick,
  application,
  isGPSEnabled,
  trackPathToPurchaseBeginCheckout,
  trackRedesignAddToCartEvent,
  deleteFromLocalStorage,
  getLocaleCodeFromUrl,
  isINMarket,
  shouldDisableLiveEventCartAction,
  hasBundleDevice,
} from 'src/utils'
import {
  currencyFormat,
  checkEnableButton,
  getWebAvailableChannel,
  isExpressCheckout,
  getShoppingContext,
  enablePdpRedesign,
  hideSubscriptionWidgetInPDP,
} from 'src/utils/commonUtils'
import { isSubscriptionRestrictedForAccountType } from 'src/deps/MultipleSubscriptionDeps'
import { Button, Col, Row, Container } from 'react-bootstrap'
import {
  customerContainer,
  promotionContainer,
  nuskinSubscriptionContainer,
  checkoutContainer,
  catalogContainer,
  accountsContainer,
  mysiteContainer,
  cartContainer,
  storeContainer,
} from 'src/models'
import {
  PayLaterMessage,
  isPaylaterMessageRequired,
} from 'src/views/components/PayPal'
import { productStatusDeps } from 'src/views/components/ProductComponents/V2ProductQuantityAndButtons/ProductStatusDeps'
import {
  KlarnaMessage,
  SigninModal,
  DrawerModal,
  Icons,
  toastState,
} from 'src/views/components'
import { FrequencyDropdownV2 } from 'src/views/components/FrequencyDropdownV2'
import { productDeps } from 'src/deps/ProductDeps'
import TagManager from 'react-gtm-module'
import { IoIosArrowBack } from 'react-icons/io'
import {
  IS_BROWSER,
  APPConfig,
  setLocalStorage,
  getBuyNowInPDP,
  getLocalStorage,
  enableCheckoutMFE,
} from 'config/appConfig'
import { consumeBuyNowResumeForCurrentPage } from 'src/utils/buyNowResumeUtils'

import {
  loadClickWrapContainer,
  retrieveAccountTypeGroupKey,
  getMemberGroupKey,
  toggleIronCladCheck,
} from 'src/utils/signUpUtils'
import loadable from '@loadable/component'
import { observable, action, when } from 'mobx'
import { offerCreationState } from 'src/utils/application'
import Skeleton from 'react-loading-skeleton'
import { pageNames } from 'src/routes/pathParams'
import { ProductReplacement } from '../ProductReplacement/ProductReplacement'
import { ShareOfferModalLoader } from 'src/views/components/CreateQuickshareLinkPopUp/ShareOfferModalLoader'
import { LoyaltyMFEContainer } from 'src/views/components/LoyaltyMFE/LoyaltyMFEContainer'
import { V2BundlePDP } from 'src/views/components/BundlePDP/V2BundlePDP'
import { BundlesWithThisItems } from 'src/views/components/ProductComponents/BundlesWithThisItems/BundlesWithThisItems'
import { ProductSkuSelection } from 'src/views/components/ProductComponents/ProductSkuDetails/ProductSkuSelection'
import './styles.scss'
import {
  isEnableExpressCheckoutMemberAgreement,
  isEnableIronCladIntegrationAPI,
} from '../../Header/deps'
import SubscribeAndSave from '../NewProductSkuDetails/SubscribeAndSave'
import BundleSubscribeBenefits from '../NewProductSkuDetails/BundleSubscribeBenefits'
import UpArrow from '../../Icons/UpArrow'
import AddToCartIcon from '../../Icons/AddToCartIcon'
import { addCartIcon } from './fixture'
import { isEquinoxMysite } from 'src/utils/mySiteUtils'
import { RegionRestrictionBanner } from 'src/views/components/RegionRestrictionBanner'
import {
  DEFAULT_SPONSOR,
  MEMBER_PRICE,
  PRICE_FACET_MEMBER,
  PRICE_FACET_WHOLESALE,
} from 'src/utils/constant'
import MicroFrontendLoader from '../../MicroFrontends/MicroFrontendLoader'
import { toPlainSnapshot } from '../../MicroFrontends/mfeSnapshot'

// Loaded on demand: the express checkout drawer only opens after a user
// clicks Buy Now, so the entire checkout page tree (CheckoutAccordions,
// CartBlock, payment forms, nu-taxid) must not be part of the initial bundle
// of every page that renders product buttons.
const ExpressCheckout = loadable(
  () => import('src/views/pages/ExpressCheckout/ExpressCheckout'),
  {
    resolveComponent: mod => mod.ExpressCheckout,
    fallback: <Skeleton rectangle={true} height={200} />,
  }
)

@observer
class V2ProductQuantityAndButtons extends React.Component {
  state = {
    isAddToCartVisibleState: true,
    isBuyNowVisibleState: true,
    isPageScrolled: false,
  }

  isMobileView = () => {
    return typeof window !== 'undefined' && window.innerWidth <= 768
  }

  checkAddToCartVisibilityState = () => {
    const addBtn = document.getElementById('add-to-cart-btn')
    let addVisible = false
    if (addBtn) {
      const rect = addBtn.getBoundingClientRect()
      addVisible =
        rect.top < window.innerHeight &&
        rect.bottom > 0 &&
        rect.left < window.innerWidth &&
        rect.right > 0 &&
        getComputedStyle(addBtn).display !== 'none' &&
        getComputedStyle(addBtn).visibility !== 'hidden' &&
        getComputedStyle(addBtn).opacity !== '0'
    }
    const buyNowBtn = document.querySelector('.express-buy-now-button')
    let buyNowVisible = false
    if (buyNowBtn) {
      const rect = buyNowBtn.getBoundingClientRect()
      buyNowVisible =
        rect.top < window.innerHeight &&
        rect.bottom > 0 &&
        rect.left < window.innerWidth &&
        rect.right > 0 &&
        getComputedStyle(buyNowBtn).display !== 'none' &&
        getComputedStyle(buyNowBtn).visibility !== 'hidden' &&
        getComputedStyle(buyNowBtn).opacity !== '0'
    }

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop
    const isPageScrolled = scrollTop > 200

    if (
      addVisible !== this.state.isAddToCartVisibleState ||
      buyNowVisible !== this.state.isBuyNowVisibleState ||
      isPageScrolled !== this.state.isPageScrolled
    ) {
      this.setState({
        isAddToCartVisibleState: addVisible,
        isBuyNowVisibleState: buyNowVisible,
        isPageScrolled: isPageScrolled,
      })
    }
  }

  shouldShowBuyNowButton = () => {
    return (
      this.isMobileView() &&
      !this.state.isAddToCartVisibleState &&
      !this.state.isBuyNowVisibleState
    )
  }

  shouldShowScrollToTopButton = () => {
    if (!this.state.isPageScrolled) {
      return false
    }
    if (this.isMobileView()) {
      return (
        !this.state.isAddToCartVisibleState && !this.state.isBuyNowVisibleState
      )
    }
    return !this.isMobileView()
  }
  checkScrollPosition = () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop
    const shouldShow = scrollTop > 100

    if (shouldShow !== this.state.showScrollToTop) {
      this.setState({ showScrollToTop: shouldShow })
    }
    if (this.isMobileView()) {
      return (
        !this.state.isAddToCartVisibleState && !this.state.isBuyNowVisibleState
      )
    }
    return !this.isMobileView()
  }
  static contextType = ApiContent
  @observable isExpressCartBtn = false
  @observable showRightDrawer = true
  @observable showModalBody = false
  @observable isLoading = false
  @observable isCreateQuickshareLinkPopUp = false
  @observable productQuickShareURL = ''
  @observable accountType = 'Preferred Customer/Member'
  @observable isFromSideDrawer = false
  @observable isPaypalEnabled = false
  @observable isKlarnaEnabled = false
  @observable isModalVisible = false
  @observable isQuickShareLoading = false
  _buyNowSignupDisposer = null
  _buyNowResumeTimer = null
  @action
  toggleModal = (props = {}) => {
    const { visibility } = props
    this.isModalVisible =
      visibility !== undefined ? visibility : !this.isModalVisible
  }
  constructor(props, context) {
    super(props, context)
    loadClickWrapContainer()
    accountsContainer.signUpIronCladCheck.clickWrap2 = false
    if (isGPSEnabled()) {
      this.initializeGpsPaymentMethods()
    } else {
      this.isPaypalEnabled =
        APPConfig.getAppConfig()?.enablePaypal == 'true' || false
      if (this.isPaypalEnabled) {
        checkoutContainer.loadBraintreeCheckoutScript()
        checkoutContainer.loadBraintreeClientScript()
      }
    }
    this.checkAddToCartVisibilityState =
      this.checkAddToCartVisibilityState.bind(this)
  }

  checkButtonVisibility = () => {
    const btn = document.getElementById('add-to-cart-btn')
  }

  getNextFocusableElement = currentElement => {
    if (!currentElement) return null

    const focusableElements = Array.from(
      document.querySelectorAll(
        'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    )

    const currentIndex = focusableElements.indexOf(currentElement)
    return focusableElements[currentIndex + 1] || null
  }

  enableLiveEvent = getLiveEventStatus()
  isEventRegisteredUser = ''

  initializeGpsPaymentMethods = async () => {
    const supportedTypes = await checkoutContainer.getPaymentFromGPS(true)
    if (supportedTypes) {
      const paymentTypeFromGps = supportedTypes.map(type => type.toLowerCase())
      this.isPaypalEnabled = paymentTypeFromGps.includes('paypal') || false
      this.isKlarnaEnabled = paymentTypeFromGps.includes('klarna') || false
      if (this.isPaypalEnabled) {
        checkoutContainer.loadBraintreeCheckoutScript()
        checkoutContainer.loadBraintreeClientScript()
      }
    }
  }

  checkEventRegisteredUser() {
    const profileResponse = customerContainer?.profileResponse
    const accountProperties = profileResponse?.accounts?.properties || []
    const userProperty = accountProperties?.filter(
      property => property?.attributeId === 'registeredEvent'
    )
    return userProperty?.[0]?.value || 'false'
  }

  getAccountType = () => {
    if (IS_BROWSER) {
      return customerContainer.profileResponse?.accounts?.type || ''
    }
    return this?.context?.customerType
  }

  isBAorPreferred = () => {
    const accountType = this.getAccountType()
    return (
      accountType === 'Brand Affiliate' ||
      accountType === 'Brand Affiliate - Business Entity' ||
      accountType === 'Preferred Customer/Member' ||
      false
    )
  }

  checkAndSetPriceOptionOnMountAndUpdate = (isFromComponentMount = false) => {
    const { shouldShowOneTimeButton, shouldShowSubscriptionButton } =
      this.getAvailableChannels()
    productState.currentlySelectedPriceOption = shouldShowOneTimeButton
      ? 'one-time-price-button'
      : 'subscription-price-button'
    // below call was made to get subscription promotion on page load
    // this is not required as both subscription & onetime facets are received in pdp call
    // hence commenting this

    // if (isFromComponentMount && !shouldShowOneTimeButton) {
    //   promotionContainer.makeV2PromotionCall(
    //     this.props.product,
    //     this.props.productCount,
    //     true
    //   )
    // }
  }
  componentDidMount = () => {
    if (IS_BROWSER) {
      this.checkAddToCartVisibilityState()
      this.checkScrollPosition()
      window.addEventListener('scroll', this.checkAddToCartVisibilityState)
      window.addEventListener('scroll', this.checkScrollPosition)
      window.addEventListener('resize', this.checkAddToCartVisibilityState)
    }
    this.checkAndSetPriceOptionOnMountAndUpdate(true)
    this.isPsContractChecked()
    this.siteObjectBasedonConvertAccountType(this.convertAccountType)
    if (this.props?.isExpressPDP && IS_BROWSER) {
      window?.addEventListener('visibilitychange', this.checkForMultipleTabs)
      window?.addEventListener('beforeunload', this.deleteCartOnBeforeUnload)
      // For IOS / MAC device using pagehide event as beforeunload is not working
      window?.addEventListener('pagehide', this.deleteCartOnBeforeUnload)
    }
    if (IS_BROWSER) {
      this.checkButtonVisibility()
      window.addEventListener('scroll', this.checkButtonVisibility)
      window.addEventListener('resize', this.checkButtonVisibility)
    }
    const isLoggedIn = customerContainer?.isRegisterUser
    if (isLoggedIn && this.props.show !== 'quickShare') {
      this.checkIroncladStatusAndShowCheckbox()
    }
    this.checkAndResumeBuyNowAfterSignup()
    // this.initializeCheckForManageSubscription()
    // currently commenting this out since there is no "manage subscription" feature
  }

  /**
   * Reopens the express checkout drawer on the product the shopper clicked
   * Buy Now on before being sent through sign-in / sign-up (IT-43426).
   */
  checkAndResumeBuyNowAfterSignup = () => {
    if (!IS_BROWSER) {
      return
    }
    if (!(this.props?.isExpressPDP || getBuyNowInPDP())) {
      return
    }
    // Consumed synchronously so sibling instances on the same page cannot
    // trigger a second drawer.
    if (!consumeBuyNowResumeForCurrentPage()) {
      return
    }
    let isResolved = false
    this._buyNowSignupDisposer = when(
      () =>
        customerContainer.isRegisterUser && !!productState.product?.productId,
      () => {
        isResolved = true
        this._buyNowSignupDisposer = null
        this._buyNowResumeTimer = setTimeout(async () => {
          this._buyNowResumeTimer = null
          await this.handleExpressBuyNow()
        }, 0)
      }
    )
    if (isResolved) {
      this._buyNowSignupDisposer = null
    }
  }

  isPsContractChecked() {
    if (!_ps) return
    const updateIronCladChecked = checked => element => {
      this.ironCladCheckedString = toggleIronCladCheck(checked, element)
      accountsContainer.isMemberAgreementChecked =
        this.ironCladCheckedString === 'clickwrap-container-2-true'
    }
    _ps.on('checked', updateIronCladChecked(true))
    _ps.on('unchecked', updateIronCladChecked(false))
  }

  siteObjectBasedonConvertAccountType = () => {
    const groupKey = retrieveAccountTypeGroupKey(this.accountType) || ''
    getMemberGroupKey(groupKey)
  }

  isRazorPaySessionPresent = () => {
    return (
      getLocalStorage('gpsRedirection') &&
      cartContainer?.cartResponse?.payments?.[0]?.name === 'Razorpay'
    )
  }

  deleteCartOnBeforeUnload = async () => {
    // Don't delete cart if Klarna session is present
    if (
      !cartContainer?.cartResponse?.properties?.klarnaSessionVerifierKey &&
      cartContainer?.cartResponse?.items?.length &&
      customerContainer?.isRegisterUser &&
      checkoutContainer.renderExpressPDPCart &&
      checkoutContainer.showExpressCheckoutDrawer &&
      checkoutContainer.showExpressCheckoutModalBody &&
      cartContainer.cartResponse?.cartType === 'EXPRESS' &&
      !isRazorPaySessionPresent()
    ) {
      await cartContainer.deleteCartItem(
        '',
        '',
        '',
        false,
        false,
        null,
        null,
        null,
        false
      )
      checkoutContainer.renderExpressPDPCart =
        checkoutContainer.showExpressCheckoutDrawer =
        checkoutContainer.showExpressCheckoutModalBody =
          false
    }
  }
  checkForMultipleTabs = async () => {
    if (
      checkoutContainer.renderExpressPDPCart &&
      checkoutContainer.showExpressCheckoutDrawer &&
      checkoutContainer.showExpressCheckoutModalBody &&
      cartContainer.cartResponse?.cartType === 'EXPRESS' &&
      !document?.hidden
    ) {
      await cartContainer.viewCart()
      if (
        cartContainer.cartResponse?.items?.[0]?.skus?.[0]?.productId ===
          this.props?.product?.productId ||
        cartContainer.cartResponse?.items?.[0]?.properties?.slug ===
          this.props?.product?.slug
      ) {
        return
      }
      checkoutContainer.renderExpressPDPCart =
        checkoutContainer.showExpressCheckoutDrawer =
        checkoutContainer.showExpressCheckoutModalBody =
          false
      setLocalStorage('isExpressCart', false)
      await cartContainer.viewCart()
    }
  }

  componentWillUnmount = () => {
    if (IS_BROWSER) {
      window.removeEventListener('scroll', this.checkAddToCartVisibilityState)
      window.removeEventListener('scroll', this.checkScrollPosition)
      window.removeEventListener('resize', this.checkAddToCartVisibilityState)
    }
    if (IS_BROWSER) {
      window?.removeEventListener('visibilitychange', this.checkForMultipleTabs)
      window?.removeEventListener('beforeunload', this.deleteCartOnBeforeUnload)
      window?.removeEventListener('pagehide', this.deleteCartOnBeforeUnload)
      window.removeEventListener('scroll', this.checkButtonVisibility)
      window.removeEventListener('resize', this.checkButtonVisibility)
    }
    checkoutContainer.renderExpressPDPCart =
      checkoutContainer.showExpressCheckoutDrawer =
      checkoutContainer.showExpressCheckoutModalBody =
        false
    if (this._offerDisposer) {
      this._offerDisposer()
      this._offerDisposer = null
    }
    if (this._buyNowSignupDisposer) {
      this._buyNowSignupDisposer()
      this._buyNowSignupDisposer = null
    }
    if (this._buyNowResumeTimer) {
      clearTimeout(this._buyNowResumeTimer)
      this._buyNowResumeTimer = null
    }
    this.isQuickShareLoading = false
    offerCreationState.isInProgress = false
  }

  checkAndMakeSubscriptionCall = async () => {
    await nuskinSubscriptionContainer.init(this.props)
  }

  initializeCheckForManageSubscription = () => {
    const customerResponse =
      customerContainer?.profileResponse?.customer ||
      customerContainer?.profileResponse
    if (customerResponse?.id) {
      this.checkAndMakeSubscriptionCall()
    } else {
      setTimeout(() => {
        this.initializeCheckForManageSubscription()
      }, 300)
    }
  }

  componentDidUpdate = prevProps => {
    if (IS_BROWSER) {
      this.checkAddToCartVisibilityState()
    }
    if (
      this.props.product.availableChannels !=
      prevProps.product.availableChannels
    ) {
      this.checkAndSetPriceOptionOnMountAndUpdate()
    }
    if (accountsContainer.showIroncladCheckbox) {
      accountsContainer.isMemberAgreementChecked =
        accountsContainer.signUpIronCladCheck?.clickWrap2 || false
    }
    if (IS_BROWSER) {
      this.checkButtonVisibility()
    }
  }

  getPriceWithCurrency = priceValue => {
    const formattedPrice = currencyFormat({
      price: priceValue || 0,
    })
    return formattedPrice
  }

  isDiscountedPrice = totalValue =>
    totalValue?.priceAfterDiscount < totalValue?.originalPrice

  isNegativeDiscount = totalValue =>
    totalValue?.priceAfterDiscount > totalValue?.originalPrice

  isBundleOrKit =
    this.props.product?.type === 'bundle' || this.props.product?.type == 'kit'

  getAvailableChannels = () => {
    const availableChannelsList = this.isBundleOrKit
      ? this.props.product?.properties?.availableChannels || ''
      : this.props.product?.availableChannels || ''

    const shouldShowOneTimeButton = checkEnableButton(
      availableChannelsList,
      getWebAvailableChannel()
    )
    const shouldShowSubscriptionButton = checkEnableButton(
      availableChannelsList,
      'subscription'
    )
    return {
      shouldShowOneTimeButton,
      shouldShowSubscriptionButton,
    }
  }
  getTotalPriceFromTotalValueNode = value => {
    // we are manually selecting the total based on price option selected
    // here only one promotion call made
    const priceFacets = value?.priceFacets || {}
    let isBAorPreferred = this.isBAorPreferred()
    /*for mysite if pricetype is set as member then we need to show wholesale/member price */
    if (!customerContainer?.isRegisterUser && isEquinoxMysite()) {
      isBAorPreferred = mysiteContainer.mysitePriceType === MEMBER_PRICE
    }
    const priceFacetPattern = this.getPriceFacetPattern(priceFacets)
    let totalValue = ''
    if (productState.currentlySelectedPriceOption === 'one-time-price-button') {
      if (isBAorPreferred) {
        const isZeroPriceAfterDiscount =
          priceFacets?.[`${priceFacetPattern} Price`]?.[
            `${priceFacetPattern} PriceAfterDiscount`
          ] === 0
        totalValue = isZeroPriceAfterDiscount
          ? 0
          : priceFacets?.[`${priceFacetPattern} Price`]?.[
              `${priceFacetPattern} PriceAfterDiscount`
            ] ||
            priceFacets?.[`${priceFacetPattern} Price`]?.[
              `${priceFacetPattern} Price`
            ]
      } else {
        const isZeroPriceAfterDiscount =
          priceFacets?.['Regular Price']?.['Regular PriceAfterDiscount'] === 0
        totalValue = isZeroPriceAfterDiscount
          ? 0
          : priceFacets?.['Regular Price']?.['Regular PriceAfterDiscount'] ||
            priceFacets?.['Regular Price']?.['Regular Price']
      }
    } else {
      if (isBAorPreferred) {
        const isZeroPriceAfterDiscount =
          priceFacets?.[`Sub ${priceFacetPattern} Price`]?.[
            `Sub ${priceFacetPattern} PriceAfterDiscount`
          ] === 0
        totalValue = isZeroPriceAfterDiscount
          ? 0
          : priceFacets?.[`Sub ${priceFacetPattern} Price`]?.[
              `Sub ${priceFacetPattern} PriceAfterDiscount`
            ] ||
            priceFacets?.[`Sub ${priceFacetPattern} Price`]?.[
              `Sub ${priceFacetPattern} Price`
            ]
      } else {
        const isZeroPriceAfterDiscount =
          priceFacets?.['Sub Retail Price']?.[
            'Sub Retail PriceAfterDiscount'
          ] === 0
        totalValue = isZeroPriceAfterDiscount
          ? 0
          : priceFacets?.['Sub Retail Price']?.[
              'Sub Retail PriceAfterDiscount'
            ] || priceFacets?.['Sub Retail Price']?.['Sub Retail Price']
      }
    }
    return totalValue
  }

  getPriceFacetPattern = (priceFacets = {}) => {
    if (
      !customerContainer?.isRegisterUser &&
      isEquinoxMysite() &&
      mysiteContainer?.mysitePriceType === MEMBER_PRICE
    ) {
      return isINMarket() ? PRICE_FACET_MEMBER : PRICE_FACET_WHOLESALE
    }
    return customerContainer?.isToShowMemberPrice(priceFacets)
      ? PRICE_FACET_MEMBER
      : PRICE_FACET_WHOLESALE
  }

  getTotalDiscountFromTotalValueNode = value => {
    // we are manually selecting the total based on price option selected
    // here only one promotion call made
    const priceFacets = value?.priceFacets || {}
    const priceFacetPattern = this.getPriceFacetPattern(priceFacets)
    let totalDiscount = ''
    if (productState.currentlySelectedPriceOption === 'one-time-price-button') {
      if (this.isBAorPreferred()) {
        totalDiscount =
          priceFacets?.[`${priceFacetPattern} Price`]?.[
            `${priceFacetPattern} PriceDiscount`
          ] || 0
      } else {
        totalDiscount =
          priceFacets?.['Regular Price']?.['Regular PriceDiscount'] || 0
      }
    } else {
      if (this.isBAorPreferred()) {
        totalDiscount =
          priceFacets?.[`Sub ${priceFacetPattern} Price`]?.[
            `Sub ${priceFacetPattern} PriceDiscount`
          ] || 0
      } else {
        totalDiscount =
          priceFacets?.['Sub Retail Price']?.['Sub Retail PriceDiscount'] || 0
      }
    }
    return totalDiscount
  }
  getTotalPriceWithCurrency = () => {
    const totalValueNode = productDeps.getTotalValueNode(this.props)
    const totalValue = this.getTotalPriceFromTotalValueNode(totalValueNode)
    return this.getPriceWithCurrency(totalValue)
  }

  renderTotalPrice = () => {
    return (
      <div className="total-price-with-label-wrapper">
        <span className="total-label" data-testid="qa-pdp-total-text">
          {i18nTranslate('pdp.total', 'Total', {
            nameSpace: 'ssr-resource',
          })}
          :
        </span>
        <span className="total-price-wrapper" data-testid="qa-pdp-total-price">
          <span className="total-price-after-discount pl-2">
            {this.getTotalPriceWithCurrency()}
          </span>
        </span>
      </div>
    )
  }

  renderInventoryStatus = (
    messageToDisplay = '',
    isGreenBackOrderMessage = false,
    dataTestId = ''
  ) => {
    if (messageToDisplay) {
      return (
        <Row
          noGutters
          className="w-100 v2-inventory-message"
          data-testid={dataTestId}>
          <p
            className={`availability-text font-weight-bold p-0 m-0 ${
              isGreenBackOrderMessage ? 'text-success' : 'text-bundle-danger'
            }`}
            aria-live="polite"
            aria-atomic="true">
            {messageToDisplay}
          </p>
        </Row>
      )
    }
    return ''
  }
  getAddToCartButtonText = () => {
    const { product = {} } = this.props
    const { dateOfAvailablity = 0, isPreOrder = false } = product
    const preOrderDateTimeStamp = new Date(dateOfAvailablity).getTime()
    const currentDateTimeStamp = Date.now()
    const isPreOrderProduct =
      isPreOrder &&
      dateOfAvailablity &&
      preOrderDateTimeStamp >= currentDateTimeStamp
    return isPreOrderProduct
      ? i18nTranslate('pdp.b2cPreOrder', 'Preorder', {
          nameSpace: 'ssr-resource',
        })
      : i18nTranslate('addToCart', 'Add to cart', {
          nameSpace: 'ssr-resource',
        })
  }

  getExpressAddToCartButtonText = () => {
    const { product = {} } = this.props
    const { dateOfAvailablity = 0, isPreOrder = false } = product
    const preOrderDateTimeStamp = new Date(dateOfAvailablity).getTime()
    const currentDateTimeStamp = Date.now()
    const isPreOrderProduct =
      isPreOrder &&
      dateOfAvailablity &&
      preOrderDateTimeStamp >= currentDateTimeStamp
    if (this.props?.isExpressPDP) {
      return (
        <>
          <span className="buynow-btn">
            {i18nTranslate('expressCheckout.buyNow', 'BUY NOW', {
              nameSpace: 'ssr-resource',
            })}
          </span>
          <span>{this.getTotalPriceWithCurrency()}</span>
          {this.isLoading && (
            <span
              className="ml-2 spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"></span>
          )}
        </>
      )
    }
  }

  resetAndTrackFrequencyView = () => {
    productState.resetFrequencyStateInPDP()
    this.trackSubscriptionFrequencyView()
  }

  checkAndRenderFrequencyDropdown = () => {
    return (
      productState.currentlySelectedPriceOption ==
        'subscription-price-button' && (
        <Col
          lg={6}
          sm={12}
          xs={12}
          className="v2-subscription-frequency-dropdown">
          <FrequencyDropdownV2
            title={i18nTranslate('cart.frequency', 'Frequency', {
              nameSpace: 'ssr-resource',
            })}
            isFromPDP={true}
            handleSubscriptionFrequency={this.handlePDPSubscriptionFrequency}
            handleFrequencyDidMount={this.resetAndTrackFrequencyView}
            handleFrequencyUnmount={productState.resetFrequencyStateInPDP}
          />
        </Col>
      )
    )
  }
  renderQuantity = () => {
    const { handleQuantityChange, productCount, product = {} } = this.props
    return (
      <V2ProductQuantity
        handleQuantityChange={handleQuantityChange}
        productCount={productCount}
        handleQuantityChangePromotion={promotionContainer.makeV2PromotionCall}
        product={product}
      />
    )
  }

  getSubscribableSubProductCount = () => {
    const { product = {} } = this.props
    const mandatoryProducts = product?.bundleMandatoryProducts || []
    const optionalProducts = product?.bundleOptionalProducts || []
    const kitProducts = product?.skuKit || []
    const allSubProducts = [
      ...mandatoryProducts,
      ...optionalProducts,
      ...kitProducts,
    ]
    const count = allSubProducts.filter(
      sp => sp?.selectedSku?.properties?.issubscription === 'true'
    ).length
    return count
  }

  renderBundleKitSubItems = () => {
    const { product = {} } = this.props
    const inventory = productState.inventory || {}
    const bundleType = product?.type || 'product'
    const isBundleView = this.props?.isBundleView || false
    const subscribableCount = this.getSubscribableSubProductCount()

    const { shouldShowSubscriptionButton } = this.getAvailableChannels()

    return (
      <V2BundlePDP
        isExpressPDP={this.props?.isExpressPDP}
        product={product}
        bundleType={bundleType}
        isBundleView={isBundleView}
        inventory={inventory}
        hideBenefitsFromSubProducts={subscribableCount > 0}
        hideSubProductSubscribeCheckbox={shouldShowSubscriptionButton}
      />
    )
  }

  renderDeviceSpecificView = (
    messageToDisplay = '',
    isGreenBackOrderMessage = false,
    dataTestId = ''
  ) => {
    const enableGlobalLoyalty = convertToBoolean(
      APPConfig?.getAppConfig()?.enableGlobalLoyalty
    )
    const enableNewPDPStyle =
      APPConfig?.getAppConfig()?.enableNewPDPStyle === 'true'
    const { product = {} } = this.props
    const isPbomProduct = productDeps.isPbomProduct(product)
    const enableLoyaltyPoints = storeContainer.getLoyaltyPointsConfig() || false
    const showLoyaltyMessage =
      convertToBoolean(product?.pointEarn) &&
      (enableGlobalLoyalty || enableLoyaltyPoints)

    return (
      <>
        {!enablePdpRedesign() && this.checkAndRenderFrequencyDropdown()}
        <Row noGutters className="d-flex price-section-view-wrapper">
          {this.renderQuantity()}
          {enablePdpRedesign() && <ProductSkuSelection {...this.props} />}

          {this.renderTotalPrice()}
        </Row>
        {showLoyaltyMessage && (
          <div className="mb-4">
            <LoyaltyMFEContainer componentName="App" isFrom="PDP" />
          </div>
        )}
        {enablePdpRedesign() &&
          enableNewPDPStyle &&
          !isPbomProduct &&
          this.props?.isExpressPDP &&
          this.renderBundleKitSubItems()}
        {enablePdpRedesign() && !product?.isBundle && (
          <BundlesWithThisItems product={product} />
        )}
      </>
    )
  }
  shouldDisableButton = (
    shouldShowOneTimeButton = false,
    shouldShowSubscriptionButton = false,
    disableOneTime = false,
    disableSubscription = false,
    isAlreadySubscribedProduct = false,
    disableBundleKitOneTime = false,
    disableBundleKitSubscription = false,
    disableAddToCartButtonForSubProducts = false
  ) => {
    // July Live event conditions for constraing add to cart button
    if (this.enableLiveEvent === 'true') {
      this.isEventRegisteredUser = this.checkEventRegisteredUser()
      const { enableCartForLiveEvent } = APPConfig?.getAppConfig()
      const isEventPhaseBlocked = shouldDisableLiveEventCartAction()

      if (
        (customerContainer.isRegisterUser &&
          this.isEventRegisteredUser === 'false') ||
        isEventPhaseBlocked
      ) {
        if (!convertToBoolean(enableCartForLiveEvent)) {
          return true
        }
      }
    }
    // CN locale users might get migrated for the July event site
    // Add to cart is disabled for them for non-event sites
    if (this.enableLiveEvent !== 'true') {
      const homeCountry = customerContainer?.getUserHomeCountry()
      const isUserFromCN = homeCountry === 'CN'
      if (isUserFromCN) {
        return true
      }
    }

    if (!shouldShowOneTimeButton && !shouldShowSubscriptionButton) {
      return true
    }
    if (disableAddToCartButtonForSubProducts) {
      return true
    }
    if (productState.currentlySelectedPriceOption == 'one-time-price-button') {
      return disableOneTime || disableBundleKitOneTime
    } else {
      return (
        disableSubscription || disableBundleKitSubscription
        // ||  isAlreadySubscribedProduct
        // || nuskinSubscriptionContainer.isToDisableSubscriptionButton
      )
      // isAlreadySubscribedProduct - currently we are allowing all users
      // irrespective of their existing subscription status
      // isToDisableSubscriptionButton to disable when subscription call is in progress
      // if user has already subscribed, we need to prevent from adding to cart
    }
  }

  handlePDPSubscriptionFrequency = selectedValue => {
    const [frequencyPeriod, frequencyType] = selectedValue?.split?.('-')
    productState.selectedFrequencyValueInPDP = {
      frequencyPeriod,
      frequencyType,
    }
  }

  toggleSubscriptionModal = () => {
    if (nuskinSubscriptionContainer.isToShowDisabledModal) {
      nuskinSubscriptionContainer.isToShowDisabledModal = false
    } else {
      this.isToShowSubscriptionModal = !this.isToShowSubscriptionModal
      nuskinSubscriptionContainer.enableCartConvertMessage = false
      nuskinSubscriptionContainer.enableGoToCart = false
    }
  }

  toggleExpressCheckoutModal = async () => {
    if (application.activeFetches !== 0) {
      return
    }
    checkoutContainer.showExpressCheckoutDrawer =
      checkoutContainer.renderExpressPDPCart =
      checkoutContainer.showExpressCheckoutModalBody =
        false
    this.isFromSideDrawer = false
    if (
      cartContainer.cartResponse?.items?.length &&
      cartContainer.cartResponse?.cartType === 'EXPRESS'
    ) {
      await cartContainer.deleteCartItem(
        '',
        '',
        '',
        false,
        false,
        null,
        null,
        null,
        true
      )
    }
    setLocalStorage('isExpressCart', false)
    deleteFromLocalStorage('isExpressPDPLogin')
    cartContainer.viewCart()
  }

  renderExpressCheckoutSkeleton = () => {
    return (
      <Container>
        <Row>
          <Col xs={12} className="d-flex justify-content-center my-2">
            <Skeleton rectangle={true} height={10} width={250} />
          </Col>
          <Col xs={6} className="my-2 px-3">
            <Skeleton
              rectangle={true}
              height={50}
              className="paymentButtonSkeleton"
            />
          </Col>
          <Col xs={6} className="my-2 px-3">
            <Skeleton
              rectangle={true}
              height={50}
              className="paymentButtonSkeleton"
            />
          </Col>
          <Col xs={12} className="mb-1">
            <hr />
          </Col>
          <Col xs={12}>
            <Skeleton
              className="mb-3"
              rectangle={true}
              height={25}
              width={80}
            />
            <Skeleton
              className="mb-3"
              rectangle={true}
              height={10}
              width={250}
            />
          </Col>
          <Col xs={9}></Col>
          {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13].map(item => (
            <Col xs={6}>
              <Skeleton rectangle={true} height={10} width={100} />
              <Skeleton className="mb-3" rectangle={true} height={35} />
            </Col>
          ))}
        </Row>
      </Container>
    )
  }

  renderExpressCheckout = () => {
    return enableCheckoutMFE() ? (
      <MicroFrontendLoader
        remoteConfig={{
          appName: 'checkout-mfe',
          component: 'ExpressCheckoutPage',
          type: 'global',
          entryGlobalName: 'checkout-mfe',
        }}
        params={{
          routerHistory: this.props.history,
          // Identity-stable plain snapshots — see mfeSnapshot.js.
          initialCartData: toPlainSnapshot(cartContainer?.cartResponse) || {},
          customerData:
            toPlainSnapshot(customerContainer?.profileResponse) || {},
          isFromPDP: true,
          isFromSideDrawer: this.isFromSideDrawer,
        }}
      />
    ) : (
      <ExpressCheckout
        isFromPDP={true}
        history={this.props?.history}
        isFromSideDrawer={this.isFromSideDrawer}
      />
    )
  }

  renderDrawer = () => {
    let title = cartContainer?.cartResponse?.items?.[0]?.skus?.[0]?.title
    if (title?.length > 40) title = 'Product Details'
    return (
      <DrawerModal
        renderView={
          checkoutContainer.showExpressCheckoutModalBody
            ? this.renderExpressCheckout
            : this.renderExpressCheckoutSkeleton
        }
        onHide={this.toggleExpressCheckoutModal}
        show={checkoutContainer.showExpressCheckoutDrawer}
        showCloseButton={false}
        testId="qa-express-buy-now-modal-header-wrapper"
        label="express checkout modal"
        title={
          <>
            {!checkoutContainer.showExpressCheckoutModalBody ? (
              <Skeleton rectangle={true} height={20} width={400} />
            ) : (
              <div
                role="button"
                className="modal-custom-title"
                tabIndex={0}
                onClick={this.toggleExpressCheckoutModal}>
                <IoIosArrowBack />
                <span>
                  {i18nTranslate('expresscart.backtotitle', 'Back to')} {title}
                </span>
              </div>
            )}
          </>
        }
        customClass="cart-single-subscription-modal modal-dialog-scrollable express-checkout-modal"
      />
    )
  }

  handleAddToCartClick = async props => {
    if (getBuyNowInPDP()) {
      setLocalStorage('isExpressCart', false)
    }
    const { isReplacementProduct = false, replacementProduct = {} } =
      props || {}

    const totalValueNode = productDeps.getTotalValueNode(this.props)
    const totalPrice = this.getTotalPriceFromTotalValueNode(totalValueNode)
    const { product = {}, productCount = 1, isQuickview = false } = this.props
    const frequencyPeriod =
      productState.selectedFrequencyValueInPDP?.frequencyPeriod || ''
    const productQty = isReplacementProduct ? 1 : productCount

    if (catalogContainer?.categoryListName?.pdp?.categoryId) {
      product.categoryId =
        catalogContainer.categoryListName.pdp.categoryId || ''
    }
    if (catalogContainer?.categoryListName?.pdp?.listName) {
      product.listName = catalogContainer.categoryListName.pdp.listName || ''
    }
    if (
      productState.currentlySelectedPriceOption == 'one-time-price-button' ||
      isReplacementProduct
    ) {
      cartContainer.addToCartClickedProductDetails = product
      await productState.handleV2OneTimeAddToCart(
        product,
        productQty,
        totalPrice,
        isReplacementProduct,
        isQuickview,
        replacementProduct
      )
    } else {
      // @##pdp_scancard
      const scanCount = product.properties?.scanQualifiedCount || ''
      let postParameters =
        nuskinSubscriptionContainer.getPostBodyForAddSubscription(
          {
            product,
            frequency: frequencyPeriod,
            quantity: productCount,
            frequencyOrder: 'VARIABLE_MULTI_ORDER',
            replacementProduct,
            isReplacementProduct,
          },
          scanCount
        )
      /**
       * @info
       * GTM Event for Add to subscription Cart
       *triggers on click of subscribe button in pdp page
       */
      if (postParameters?.[0]) {
        postParameters[0].price = totalPrice || 0
      }
      if (enablePdpRedesign() && enableNewFeature('enableGTMAddToCartEvent')) {
        const enrichedPostParameters = postParameters.map(item => {
          const sku = item?.skus?.[0] || {}
          const productSku = product?.sku?.[0] || product?.skus?.[0] || {}
          const skusArray = Array.isArray(item?.skus) ? item?.skus : []

          // Extract promotion data for coupon, discount, and offer
          const promotion = product?.promotion || []
          const promotionArray = Array.isArray(promotion) ? promotion : []

          return {
            ...item,
            isfromsubscription: true,
            itemId: item?.itemId || product?.itemId,
            id: product?.id || product?.productId || item?.productId,
            category:
              product?.category ||
              product?.properties?.productCategory ||
              product?.properties?.categoryId ||
              product?.categoryId,
            properties: {
              ...product?.properties,
              name: product?.properties?.name,
              brand: product?.properties?.brand,
              categoryId:
                product?.properties?.categoryId || product?.categoryId,
            },
            promotion: promotionArray,
            skus:
              skusArray.map(s => ({
                ...s,
                skuProperties:
                  s?.skuProperties || productSku?.skuProperties || {},
                properties: s?.properties || productSku?.properties || {},
                price: s?.price || productSku?.price || 0,
                promotion: promotionArray,
                totalValue: {
                  originalPrice: s?.price || productSku?.price || totalPrice,
                  priceAfterDiscount:
                    s?.priceAfterMarkdown || s?.price || totalPrice,
                  totaldiscount:
                    (s?.price || productSku?.price || totalPrice) -
                    (s?.priceAfterMarkdown || s?.price || totalPrice),
                },
              })) ||
              product?.skus ||
              [],
            unitValue: {
              priceAfterDiscount:
                totalPrice || sku?.priceAfterMarkdown || sku?.price || 0,
            },
            totalValue: {
              priceAfterDiscount:
                totalPrice || sku?.priceAfterMarkdown || sku?.price || 0,
              discount:
                (sku?.price || 0) -
                (sku?.priceAfterMarkdown || sku?.price || 0),
              totaldiscount:
                (sku?.price || 0) -
                (sku?.priceAfterMarkdown || sku?.price || 0),
            },
          }
        })

        // Extract offer message from promotion
        const offerMessage =
          Array.isArray(product?.promotion) && product.promotion.length > 0
            ? product.promotion[0]?.message ||
              product.promotion[0]?.displayMessage ||
              ''
            : ''

        trackRedesignAddToCartEvent({
          type: 'add_to_cart',
          responseData: enrichedPostParameters,
          quantity: productCount || '',
          price: totalPrice || 0,
          item_type: product?.item_type || product?.type || 'product',
          item_view: 'PDP',
          sponsorId:
            accountsContainer?.getAccountSponsorId?.() || DEFAULT_SPONSOR,
          offer: offerMessage,
        })
      } else {
        TagManager.dataLayer({
          dataLayer: {
            event: 'addToSubscriptionCart',
            item_name: this.props?.product?.properties?.name || '',
            pagePath: this.props.history?.location?.pathname || '',
            pageTitle: 'Product Details',
            subscriptionInfo: postParameters,
            platform: 'equinox',
          },
        })
      }
      await nuskinSubscriptionContainer.addSubscription(
        postParameters,
        product || {},
        true
      )
    }
  }
  handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }
  shouldShowSigninPopupOnBuyNow = () => {
    const shoppingContext = getShoppingContext()
    const enableGuestForWeb = isGuestCheckoutEnabledForWeb()
    const enableGuestForPoMysite = convertToBoolean(
      APPConfig?.getAppConfig()?.enableGuestCheckoutForPOMysite
    )
    let isGuestCheckoutEnabled = false
    // refer isGuestCheckoutEligible in cart.js
    if (Object.keys(shoppingContext).length > 0 && enableGuestForPoMysite) {
      const wholesale =
        shoppingContext?.overrides?.showWholeSalePricing || false
      isGuestCheckoutEnabled = !wholesale
    } else if (enableGuestForWeb) {
      isGuestCheckoutEnabled = true
    }
    return !customerContainer.isRegisterUser && !isGuestCheckoutEnabled
  }
  checkIroncladStatusAndShowCheckbox = async () => {
    const accountType =
      customerContainer.profileResponse?.accounts?.accountType || ''
    const locale = getLocaleCodeFromUrl() || 'en_US'
    const countryCode = locale.includes('_')
      ? locale.split('_')[1].toUpperCase()
      : locale.toUpperCase()
    const memberAgreementContractMap = {
      US: APPConfig?.getAppConfig()?.usMemberAgreementContract,
      CA: APPConfig?.getAppConfig()?.caMemberAgreementContract,
    }
    const memberAgreementContract =
      memberAgreementContractMap[countryCode] ||
      APPConfig?.getAppConfig()?.memberAgreementContract ||
      APPConfig?.getAppConfig()?.usMemberAgreementContract
    if (
      accountType === 'Preferred Customer/Member' &&
      isEnableExpressCheckoutMemberAgreement() &&
      isEnableIronCladIntegrationAPI()
    ) {
      this.isFromSideDrawer = true
      const sid = APPConfig?.getAppConfig()?.ironCladSiteAccessId
      const groupKey = APPConfig?.getAppConfig()?.ironCladMemberCWG2Key
      const sig = customerContainer?.profileResponse?.referenceAttribute || ''
      const retriveData = await retriveAgreement(sid, groupKey)
      let cidString = ''
      if (
        retriveData?.contract_data &&
        typeof retriveData.contract_data === 'object'
      ) {
        const entries = Object.entries(retriveData.contract_data)
        const foundEntry = entries.find(
          ([key, obj]) => obj?.title === memberAgreementContract
        )
        if (foundEntry) {
          const [foundKey, foundObject] = foundEntry
          cidString = foundKey
          foundObject.contractKey = foundKey
          accountsContainer.isMemberAgreementCheckedData = foundObject
        }
      }
      if (sid && sig && groupKey && cidString) {
        const isAccepted = await checkAgreedTermStatus(
          sid,
          sig,
          groupKey,
          cidString
        )
        if (isAccepted && typeof isAccepted === 'object') {
          if (Object.values(isAccepted)[0] === false) {
            accountsContainer.showIroncladCheckbox = true
          } else {
            accountsContainer.isMemberAgreementChecked = true
          }
        }
      }
    }
  }

  handleExpressBuyNow = async props => {
    const showSigninPopup = this.shouldShowSigninPopupOnBuyNow()
    if (showSigninPopup) {
      this.toggleModal({
        visibility: true,
      })
      return
    }
    this.checkIroncladStatusAndShowCheckbox()
    const { isReplacementProduct = false, replacementProduct = {} } =
      props || {}
    const totalValueNode = productDeps.getTotalValueNode(this.props)
    const totalPrice = this.getTotalPriceFromTotalValueNode(totalValueNode)
    const { product = {}, productCount = 1, isQuickview = false } = this.props
    const frequencyPeriod =
      productState.selectedFrequencyValueInPDP?.frequencyPeriod || ''

    setLocalStorage('isExpressCart', true)
    this.isLoading = true
    await cartContainer.viewCart()

    if (catalogContainer?.categoryListName?.pdp?.categoryId) {
      product.categoryId =
        catalogContainer.categoryListName.pdp.categoryId || ''
    }
    if (catalogContainer?.categoryListName?.pdp?.listName) {
      product.listName = catalogContainer.categoryListName.pdp.listName || ''
    }

    if (
      cartContainer.cartResponse?.items?.length &&
      cartContainer.cartResponse?.cartType === 'EXPRESS'
    ) {
      await cartContainer.deleteCartItem(
        '',
        '',
        '',
        false,
        false,
        null,
        null,
        null,
        true
      )
    }
    const response = await productState.handleV2OneTimeAddToCart(
      product,
      productCount,
      totalPrice,
      isReplacementProduct,
      isQuickview,
      replacementProduct
    )
    if (checkoutContainer.isSuccessResponse(response)) {
      const cartItems = cartContainer?.cartResponse?.items || []
      const cartValue = cartContainer?.cartResponse?.value || {}
      const isBA = this.isBAorPreferred()
      trackPathToPurchaseBeginCheckout({
        responseData: cartItems,
        sponsorId:
          accountsContainer?.getAccountSponsorId?.() || DEFAULT_SPONSOR,
        discount: cartValue?.itemDiscount || 'NA',
        item_list_name: 'express_checkout',
        item_persistent: false,
        totalValue: cartValue?.grandTotal || 0,
      })

      this.checkProductAndCustomerType()
      this.isLoading = false
      checkoutContainer.renderExpressPDPCart =
        checkoutContainer.showExpressCheckoutModalBody =
        checkoutContainer.showExpressCheckoutDrawer =
          true
      setLocalStorage('isExpressPDPLogin', true)
    } else {
      this.isLoading = false
      const errorCode = response?.code
      if (errorCode === 'EOIND00013') {
        toastState.setToastMessage(
          i18nTranslate(
            'cart.homeMarket',
            'Please switch to your home market to make a purchase.'
          ),
          false
        )
        return
      }
    }
  }

  handleCreateQuickshareLink = async () => {
    const { product = {} } = this.props

    const isProductOfferAdminEnabled = convertToBoolean(
      APPConfig.getAppConfig()?.enableProductOfferV2
    )

    if (isProductOfferAdminEnabled) {
      this.isQuickShareLoading = true
      offerCreationState.isInProgress = true
      this.isCreateQuickshareLinkPopUp = true
      this.productQuickShareURL = ''
      return
    }

    // Legacy flow: Use catalog API to generate quickshare link
    const products = [
      {
        isBaseSku: false,
        qty: 1,
        sku: '',
        type: '',
        variantSelected: {},
      },
    ]
    if (productDeps.isBundleData(productState.product)) {
      const bundleData = productDeps.getBundleData(productState.product)
      bundleData?.skus?.map(item => {
        if (
          item?.type?.toLowerCase() === 'mandatory' ||
          item?.type?.toLowerCase() === 'optional'
        ) {
          products[0].variantSelected[item.productId] = item?.skuId || ''
        } else {
          products[0].sku = item?.skuId || ''
          products[0].type = item?.type || ''
        }
      })
    } else {
      products[0].sku = productState?.product?.selectedSku?.identifier || ''
      products[0].type = 'variants'
    }
    const productName = productState?.product?.name || ''
    const response = await catalogContainer.getPdpQuickShare(
      products,
      productName
    )
    if (
      checkoutContainer.isSuccessResponse(response) &&
      response?.shareLink?.shareURL
    ) {
      this.isCreateQuickshareLinkPopUp = true
      this.productQuickShareURL = response?.shareLink?.shareURL || ''
    } else {
      const errorMessage =
        response.message ||
        i18nTranslate(
          'subscription.somethingwentwrong',
          'Sorry, something went wrong. Please try again.'
        )
      toastState.setToastMessage(errorMessage, false)
    }
    TagManager.dataLayer({
      dataLayer: {
        event: 'create_quickshare',
        name: product?.name || '',
        id: product?.skuId || product?.productId || '',
        price: productDeps?.getUnitValue(this.props)?.priceAfterDiscount || 0,
        category: product?.categoryId || '',
        variant: product?.skuSelected?.variantLabel || '',
        quantity: '1',
        link_text: i18nTranslate(
          'pdp.createQuickShareLink',
          'Create Quickshare Link',
          {
            nameSpace: 'ssr-resource',
          }
        ),
        brand: product?.brand || '',
        platform: 'equinox',
        link_url: this.productQuickShareURL,
      },
    })
  }

  handleCreateQuickshareClose = () => {
    this.isCreateQuickshareLinkPopUp = false
    this.productQuickShareURL = ''
    if (this._offerDisposer) {
      this._offerDisposer()
    }
    this._offerDisposer = when(
      () => application.activeFetches === 0,
      () => {
        this.isQuickShareLoading = false
        offerCreationState.isInProgress = false
        this._offerDisposer = null
      }
    )
  }

  handleOfferCreatedSuccess = () => {
    if (this._offerDisposer) {
      this._offerDisposer()
    }
    this._offerDisposer = when(
      () => application.activeFetches === 0,
      () => {
        this.isQuickShareLoading = false
        offerCreationState.isInProgress = false
        this._offerDisposer = null
      }
    )
  }

  renderQuickShareButton = () => {
    const getPOQuickShareOnPDP = convertToBoolean(
      APPConfig.getAppConfig().enablePOQuickShareOnPDP
    )
    if (!getPOQuickShareOnPDP || this.getAccountType() !== 'Brand Affiliate')
      return null

    return (
      <>
        <Row className="w-100 pdp-create-quickshare-link">
          <Button
            className="v2-pdp-create-quickshare-link-button"
            data-testid="qa-pdp-create-quickshare-link"
            onClick={this.handleCreateQuickshareLink}
            disabled={this.isQuickShareLoading}>
            <Icons
              name="product-icon"
              icontype="quickshare-link-icon"
              width="25px"
              height="24px"
              viewBox="0 0 25 24"
              className="pdp-create-quickshare-link-icon"
            />
            {this.props.show === 'quickShare'
              ? !application?.isMobile
                ? i18nTranslate('quickshare_link', 'QuickShare Link', {
                    nameSpace: 'ssr-resource',
                  })
                : i18nTranslate('quick_share', 'QuickShare', {
                    nameSpace: 'ssr-resource',
                  })
              : i18nTranslate(
                  'create_quickshare_link',
                  'Create Quickshare Link',
                  { nameSpace: 'ssr-resource' }
                )}
          </Button>
        </Row>
        <ShareOfferModalLoader
          showModal={this.isCreateQuickshareLinkPopUp}
          onClose={this.handleCreateQuickshareClose}
          url={this.productQuickShareURL}
          product={this.props?.product}
          showOfferDashboardMessage={true}
          onOfferCreated={this.handleOfferCreatedSuccess}
        />
      </>
    )
  }

  trackSubscriptionFrequencyView = () => {
    const frequencyPeriod =
      productState.selectedFrequencyValueInPDP?.frequencyPeriod || ''
    const frequencyType =
      productState.selectedFrequencyValueInPDP?.frequencyType || ''
    const totalValueNode = productDeps.getTotalValueNode(this.props)
    const totalValue = this.getTotalPriceFromTotalValueNode(totalValueNode)
    const totalDiscount =
      this.getTotalDiscountFromTotalValueNode(totalValueNode)
    const linkText = i18nTranslate('pdp.subscribesave', 'Subscribe & save', {
      nameSpace: 'ssr-resource',
    })
    const linkUrl = window.location.pathname
    trackV2SubscriptionButtonClick({
      event: 'subscription_detail_item',
      item_id: this.props?.product?.skuId || '',
      item_name: this.props?.product?.properties?.name || '',
      item_discount: totalDiscount,
      item_total: totalValue || 0,
      item_quantity: this.props.productCount || '1',
      item_frequency: frequencyPeriod + ' ' + frequencyType,
      link_text: linkText,
      link_url: linkUrl,
      processing_day: '',
    })
  }

  checkProductAndCustomerType = () => {
    const isNotEligibleForGuestCheckout =
      cartContainer.isProductUserTypeNotEligibleForGuestCheckout()
    if (isNotEligibleForGuestCheckout && !customerContainer.isRegisterUser) {
      this?.props?.history?.push(pageNames?.signIn)
    }
  }

  render() {
    const { handleQuantityChange, productCount, product = {} } = this.props
    const getPOQuickShareOnPDP = convertToBoolean(
      APPConfig.getAppConfig().enablePOQuickShareOnPDP
    )
    const iconType = 'quickshare-link-icon'
    let isBundleProduct = productDeps.isBundleData(product)
    const selectedSku =
      product?.selectedSku ||
      productDeps.getUserSelectedSku({
        sku: product?.sku,
        skuId: product?.skuId,
      })
    const isproductStatus =
      selectedSku?.properties?.productStatus?.toLowerCase() == 'discontinued'
    const enableDiscontinuedSKUReplacement =
      convertToBoolean(
        APPConfig?.getAppConfig()?.enableDiscontinuedSKUReplacement
      ) || false
    const isReplacementProductStatus =
      Array.isArray(product?.replacementProduct) &&
      product?.replacementProduct?.every(
        item => typeof item === 'object' && item !== null
      ) &&
      isproductStatus &&
      !isBundleProduct &&
      enableDiscontinuedSKUReplacement
    const replacementSkuId =
      selectedSku?.properties?.discontinuedSkuReplacement || ''
    const relavantReplacementProduct =
      productDeps.findRelevantReplacementProduct(product, replacementSkuId)
    const isReplacementProductStatusInactive =
      relavantReplacementProduct?.sku?.[0]?.properties?.productStatus ==
      'inactive'
    const totalValueNode = productDeps.getTotalValueNode(this.props)
    const totalPrice = this.getTotalPriceFromTotalValueNode(totalValueNode)
    const userCountry = customerContainer.getUsersCountry()
    const isCrossMarketAllowedFlag =
      customerContainer.isCrossMarketAllowed() || false
    const { shouldShowOneTimeButton, shouldShowSubscriptionButton } =
      this.getAvailableChannels()
    const {
      messageToDisplay = '',
      disableOneTime = false,
      disableSubscription = false,
      isGreenBackOrderMessage = false,
      disableBundleKitOneTime = false,
      disableBundleKitSubscription = false,
      dataTestId = '',
      disableAddToCartButtonForSubProducts = false,
    } = productStatusDeps.getV2ProductLevelInventoryStatus(
      product,
      productCount
    )
    const isAlreadySubscribedProduct =
      nuskinSubscriptionContainer.isAlreadyASubscribedProduct(this.props)
    const unitValue = productDeps.getUnitValue(this.props)
    const { show } = this.props
    const isDirectSellerButton =
      typeof isFeatureEnabled === 'function' &&
      isFeatureEnabled('enableDirectSellerButton') &&
      (typeof productDeps?.isDirectSellerProduct === 'function'
        ? productDeps.isDirectSellerProduct(productState?.product)
        : false)
    if (show === 'quickShare') return this.renderQuickShareButton()

    return (
      <>
        {isReplacementProductStatus &&
        !isReplacementProductStatusInactive &&
        Object.keys(relavantReplacementProduct).length > 0 ? (
          <ProductReplacement
            {...this.props}
            handleAddToCartClick={this.handleAddToCartClick}
            replacementProduct={relavantReplacementProduct}
          />
        ) : (
          <Row
            noGutters
            className={`${this.isPaypalEnabled ? '' : 'v2-pdp-wrapper'} w-100`}>
            <>
              {!enablePdpRedesign() &&
                (!this.props?.isExpressPDP || getBuyNowInPDP()) && (
                  <Row noGutters className="w-100 price-buttons-wrapper">
                    <PriceButtonsForPDP
                      {...this.props}
                      unitValue={unitValue}
                      shouldShowOneTimeButton={shouldShowOneTimeButton}
                      shouldShowSubscriptionButton={
                        shouldShowSubscriptionButton
                      }
                    />
                  </Row>
                )}
            </>
            <Col
              noGutters
              className="w-100 v2-quantity-total-frequency-wrapper">
              {this.renderDeviceSpecificView(
                messageToDisplay,
                isGreenBackOrderMessage,
                dataTestId
              )}
            </Col>

            {enablePdpRedesign() &&
              !hideSubscriptionWidgetInPDP() &&
              !isSubscriptionRestrictedForAccountType() &&
              !isDirectSellerButton &&
              isNonEventOrEventWithSub() && (
                <SubscribeAndSave
                  key={product?.productId}
                  {...this.props}
                  subProduct={product?.selectedSku}
                  shouldSubscribeOnly={!shouldShowOneTimeButton}
                  hideBenefits={
                    this.getSubscribableSubProductCount() > 0 &&
                    !shouldShowSubscriptionButton
                  }
                />
              )}

            {enablePdpRedesign() &&
              productDeps.isEnableSubProductsSubscribeSelect() &&
              !isDirectSellerButton &&
              this.getSubscribableSubProductCount() > 0 &&
              !shouldShowSubscriptionButton &&
              isNonEventOrEventWithSub() &&
              (!isFeatureEnabled('enableSubscriptionForDeviceBundlesOnly') ||
                hasBundleDevice(product)) && <BundleSubscribeBenefits />}

            {!enablePdpRedesign() &&
              this.renderInventoryStatus(
                messageToDisplay,
                isGreenBackOrderMessage,
                dataTestId
              )}

            {(shouldShowOneTimeButton || shouldShowSubscriptionButton) && (
              <Row noGutters className="w-100 v2-add-to-cart-wrapper">
                {(getBuyNowInPDP() || !isExpressCheckout()) && (
                  <Button
                    id="add-to-cart-btn"
                    className="v2-add-to-cart-button"
                    data-testid="qa-pdp-add-to-cart"
                    onClick={async event => {
                      await this.handleAddToCartClick()
                    }}
                    onKeyDown={async event => {
                      if (event.key === 'Enter') {
                        event.preventDefault()
                        const currentButton = event.currentTarget

                        await this.handleAddToCartClick()

                        setTimeout(() => {
                          if (
                            currentButton &&
                            document.contains(currentButton)
                          ) {
                            currentButton.focus()
                          }
                        }, 100)

                        const nextFocusableElement =
                          this.getNextFocusableElement(currentButton)
                        if (nextFocusableElement) {
                          setTimeout(() => {
                            const handleNextTab = e => {
                              if (e.key === 'Tab' && !e.shiftKey) {
                                e.preventDefault()
                                nextFocusableElement.focus()
                                document.removeEventListener(
                                  'keydown',
                                  handleNextTab
                                )
                              }
                            }
                            document.addEventListener(
                              'keydown',
                              handleNextTab,
                              { once: true }
                            )
                          }, 150)
                        }
                      }
                    }}
                    disabled={this.shouldDisableButton(
                      shouldShowOneTimeButton,
                      shouldShowSubscriptionButton,
                      disableOneTime,
                      disableSubscription,
                      isAlreadySubscribedProduct,
                      disableBundleKitOneTime,
                      disableBundleKitSubscription,
                      disableAddToCartButtonForSubProducts
                    )}>
                    <div
                      className={`add-to-cart-button-label ${
                        getBuyNowInPDP() ? 'text-uppercase' : ''
                      }`}>
                      {enablePdpRedesign() ? (
                        <>
                          {addCartIcon()}
                          {this.getAddToCartButtonText()} ({productCount})
                        </>
                      ) : (
                        this.getAddToCartButtonText()
                      )}
                    </div>
                  </Button>
                )}
                {!isCrossMarketAllowedFlag && (
                  <div className="region-restriction-banner-hover-wrapper">
                    <RegionRestrictionBanner />
                  </div>
                )}
                {this.props?.isExpressPDP && (
                  <Button
                    className={
                      enablePdpRedesign()
                        ? 'pdp-redesign-express-buy-now'
                        : 'v2-add-to-cart-button express-buy-now-button'
                    }
                    data-testid="qa-pdp-buy-now"
                    onClick={this.handleExpressBuyNow}
                    variant="light"
                    tabIndex={0}
                    disabled={
                      this.shouldDisableButton(
                        shouldShowOneTimeButton,
                        shouldShowSubscriptionButton,
                        disableOneTime,
                        disableSubscription,
                        isAlreadySubscribedProduct,
                        disableBundleKitOneTime,
                        disableBundleKitSubscription
                      ) ||
                      (productState.currentlySelectedPriceOption ===
                        'subscription-price-button' &&
                        this.props?.isExpressPDP)
                    }>
                    <div className="add-to-cart-button-label">
                      {this.getExpressAddToCartButtonText()}
                    </div>
                  </Button>
                )}
                {!enablePdpRedesign() && this.renderQuickShareButton()}
              </Row>
            )}
            {this.shouldShowScrollToTopButton() && enablePdpRedesign() && (
              <div className="custom-scroll-top-btn-wrapper">
                <Button
                  className="custom-scroll-top-btn"
                  onClick={this.handleScrollToTop}
                  data-testid="qa-top-btn"
                  variant="outline-secondary">
                  <UpArrow
                    {...(!this.isMobileView() && { height: 24, width: 24 })}
                  />{' '}
                  <span className="top-label-web">
                    {i18nTranslate('top_label', 'Top')}
                  </span>
                </Button>
              </div>
            )}
            {this.shouldShowBuyNowButton() && enablePdpRedesign() && (
              <div className="custom-bottom-buttons">
                <div className="custom-bottom-buttons-container">
                  <Button
                    className="custom-add-btn"
                    onClick={() => this.handleAddToCartClick()}
                    data-testid="qa-add-btn"
                    variant="primary"
                    disabled={this.shouldDisableButton(
                      shouldShowOneTimeButton,
                      shouldShowSubscriptionButton,
                      disableOneTime,
                      disableSubscription,
                      isAlreadySubscribedProduct,
                      disableBundleKitOneTime,
                      disableBundleKitSubscription
                    )}>
                    <AddToCartIcon />
                    {i18nTranslate('viewCart.searchCardAdd', 'Add', {
                      nameSpace: 'ssr-resource',
                    })}{' '}
                    ({productCount})
                  </Button>
                  <Button
                    className="custom-buy-now-btn"
                    onClick={() => this.handleExpressBuyNow()}
                    data-testid="qa-buy-now-btn"
                    variant="light"
                    disabled={
                      this.shouldDisableButton(
                        shouldShowOneTimeButton,
                        shouldShowSubscriptionButton,
                        disableOneTime,
                        disableSubscription,
                        isAlreadySubscribedProduct,
                        disableBundleKitOneTime,
                        disableBundleKitSubscription
                      ) ||
                      (productState.currentlySelectedPriceOption ===
                        'subscription-price-button' &&
                        this.props?.isExpressPDP)
                    }>
                    {i18nTranslate('expressCheckout.buyNow', 'BUY NOW', {
                      nameSpace: 'ssr-resource',
                    })}
                  </Button>
                </div>
              </div>
            )}
            {/* Klarna to be shown only when one time option is available */}
            {/*enableBtn?.atbBtn &&  */}
            {shouldShowOneTimeButton && totalPrice > 0 && (
              <div className="klarna-bundle-total-price-wrapper">
                <KlarnaMessage
                  price={totalPrice || 0}
                  id={'klarna-pdp-message-bundle-total-price'}
                  data-key={'credit-promotion-badge'}
                />
              </div>
            )}
            <SigninModal
              isVisible={this.isModalVisible}
              onHideSignInModal={() =>
                this.toggleModal({
                  visibility: false,
                })
              }
              checkoutUrl={this.props}
              isFromPDPBuyNow={!!(this.props?.isExpressPDP || getBuyNowInPDP())}
            />
            {/* Paypal paylater message for Bundle and Kit */}
            {isPaylaterMessageRequired(userCountry) &&
              this.isPaypalEnabled &&
              totalPrice > 0 && (
                <div className={'paylater-bundle-total-price-wrapper'}>
                  <PayLaterMessage
                    amount={totalPrice.toString()}
                    key={'paylater-bundle-total-price-wrapper'}
                    id={'paylater-bundle-total-price-wrapper'}
                  />
                </div>
              )}
            {checkoutContainer.renderExpressPDPCart &&
              isExpressCheckout() &&
              this.renderDrawer()}
          </Row>
        )}
      </>
    )
  }
}

export { V2ProductQuantityAndButtons }
export default V2ProductQuantityAndButtons
